import { Injectable, inject } from '@angular/core';
import { FileModel } from '../../../models';
import { FILE_PREVIEW_PROCESSORS, FilePreviewProcessor } from './file-preview-processor';

/** Resolves the preview processor for a file. Registration order on the token is the priority order. */
@Injectable()
export class FilePreviewProcessorFactory {
  private readonly _processors = inject(FILE_PREVIEW_PROCESSORS);

  getProcessor(file: Partial<FileModel>): FilePreviewProcessor {
    const processor = this._processors.find((p) => p.supports(file));
    if (!processor) {
      // Unreachable while BlobFetchProcessor (supports everything) is registered.
      throw new Error('FilePreviewProcessorFactory :: no processor registered for file');
    }
    return processor;
  }

  /** Next matching processor after `failed` — powers the URL→blob runtime fallback. */
  getFallback(file: Partial<FileModel>, failed: FilePreviewProcessor): FilePreviewProcessor | null {
    const start = this._processors.indexOf(failed) + 1;
    return this._processors.slice(start).find((p) => p.supports(file)) ?? null;
  }
}
